function devicesToProcess (userData) {
  const groupIds = userData.groups.map(g => g.id)
  const devices = userData.byGroup ? userData.devices.filter(d => !groupIds.includes(d.groupId)) : userData.devices
  devices.sort((a, b) => (a.name > b.name) ? 1 : -1)
  console.log('LOADING_MESSAGE:' + devices.map(d => d.name).join(', '))
  return devices
}

exports.deviceName = function deviceName (device) {
  return device.name + (device.attributes.license_plate ? ', ' + device.attributes.license_plate : '') + (device.model ? ', ' + device.model : '')
}

exports.devicesToProcess = devicesToProcess
